import formatMoney from '../formatMoney';

const updatePrice = ({
  priceContainerEls,
  price,
  compareAtPrice,
  productPerPriceEls,
  variant,
  subscriptionLabelPriceEl,
  sellingPlanEls,
}) => {
  if (!priceContainerEls.length) return;

  priceContainerEls.forEach((container) => {
    const priceEl = container.querySelector('[data-product-price]');
    const compareAtPriceEl = container.querySelector('[data-product-compare-at-price]');
    const totalPrice = container.nextElementSibling;

    if (compareAtPriceEl) {
      if (compareAtPrice > price) {
        compareAtPriceEl.textContent = formatMoney(compareAtPrice);
        compareAtPriceEl.classList.remove('hidden');
      } else {
        compareAtPriceEl.textContent = '';
        compareAtPriceEl.classList.add('hidden');
      }
    }

    if (totalPrice && variant.price) {
      totalPrice.textContent = formatMoney(variant.price);
    }
    priceEl.textContent = formatMoney(price);
  });

  if (sellingPlanEls && variant && variant.selling_plan_allocations) {
    const frequencyEls = Array.from(sellingPlanEls).filter(input =>
      input.hasAttribute('data-selling-plan-frequency')
    );

    if (subscriptionLabelPriceEl && frequencyEls.length > 0) {
      const checkedInput = frequencyEls.find(input => input.checked);
      const selectedInput = checkedInput || frequencyEls[0];
      const selectedSellingPlanId = Number(selectedInput.value);
      const matchingAllocation = variant.selling_plan_allocations.find(
        alloc => alloc.selling_plan_id === selectedSellingPlanId
      );

      if (matchingAllocation) {
        subscriptionLabelPriceEl.textContent = formatMoney(matchingAllocation.price);
      }
    }
  }
};

export default updatePrice;
